module.exports = __webpack_public_path__ + "img/PopUpBanner_AM_Halloween_9.44cbfeff.png";